import React from "react";

export default function LoadingSkeleton() {
  const shimmer = {
    background: "linear-gradient(90deg,#f5f5f5,#eaeaea,#f5f5f5)",
    animation: "shimmer 1.2s infinite",
    backgroundSize: "300px 100%",
  };

  return (
    <>
      <div
        style={{
          height: 56,
          display: "grid",
          gridTemplateColumns: "28px 1fr 24px 24px 24px 28px",
          alignItems: "center",
          gap: 12,
          padding: "0 12px",
          borderBottom: "1px solid #E5E5E5",
          background: "#fff",
        }}
      >
        <div style={{ width: 28, height: 28, borderRadius: "50%", ...shimmer }} />
        <div style={{ flex: 1, height: 12, borderRadius: 6, ...shimmer }} />
        <div style={{ width: 24, height: 24, borderRadius: 6, ...shimmer }} />
        <div style={{ width: 24, height: 24, borderRadius: 6, ...shimmer }} />
        <div style={{ width: 24, height: 24, borderRadius: 6, ...shimmer }} />
        <div style={{ width: 28, height: 28, borderRadius: "50%", ...shimmer }} />
      </div>

      <div style={{ flex: 1, overflow: "hidden", padding: 12 }}>
        {[...Array(6)].map((_, i) => (
          <div key={i} style={{ marginBottom: 12 }}>
            <div style={{ width: 36, height: 36, borderRadius: "50%", ...shimmer, marginBottom: 8 }} />
            <div style={{ width: "85%", height: 12, borderRadius: 6, ...shimmer, marginBottom: 6 }} />
            <div style={{ width: "70%", height: 12, borderRadius: 6, ...shimmer }} />
          </div>
        ))}
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          padding: 12,
          borderTop: "1px solid #E5E5E5",
          background: "#fff",
        }}
      >
        <div style={{ flex: 1, height: 36, borderRadius: 18, ...shimmer }} />
        <div style={{ width: 36, height: 36, borderRadius: 8, ...shimmer }} />
      </div>

      <style>
        {`
          @keyframes shimmer {
            0% { background-position: -300px 0; }
            100% { background-position: 300px 0; }
          }
        `}
      </style>
    </>
  );
}
